const EVENT_REGISTRATION = 'event-registration';

const registrationEventTrigger = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const currentQuery = urlParams.get('registration');
  if (currentQuery) {
    const event = new CustomEvent(EVENT_REGISTRATION);
    document.dispatchEvent(event);
  }
};

export {EVENT_REGISTRATION, registrationEventTrigger};